import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Stars } from './Stars';
import { salesNames } from '../data/salesNames';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/dpPwDsYjA9MKgeko8FLieC/mokupcodigocortiso.png';
const START_DELAY = 25000;
const VISIBLE_MS = 4000;
const MIN_GAP = 4000;
const MAX_GAP = 18000;
interface Pop {
  id: number;
  name: string;
  minutes: number;
  type: 'access' | 'rating';
}
const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
function createPop(id: number, previousType: Pop['type'] | null): Pop {
  const type: Pop['type'] = previousType === 'access' ? 'rating' : previousType === 'rating' ? 'access' : 'access';
  return {
    id,
    name: salesNames[randomInt(0, salesNames.length - 1)],
    minutes: randomInt(1, 16),
    type
  };
}
export function SalesPops() {
  const [pop, setPop] = useState<Pop | null>(null);
  const counter = useRef(0);
  const lastType = useRef<Pop['type'] | null>(null);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    const schedule = (delay: number) => {
      const showId = window.setTimeout(() => {
        counter.current += 1;
        const next = createPop(counter.current, lastType.current);
        lastType.current = next.type;
        setPop(next);
        const hideId = window.setTimeout(() => {
          setPop(null);
          schedule(randomInt(MIN_GAP, MAX_GAP));
        }, VISIBLE_MS);
        timers.current.push(hideId);
      }, delay);
      timers.current.push(showId);
    };
    schedule(START_DELAY);
    return () => {
      timers.current.forEach(t => window.clearTimeout(t));
      timers.current = [];
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-2 left-0 z-30 w-full px-3 sm:left-5 sm:bottom-5 sm:w-auto sm:px-0 lg:bottom-6" aria-live="polite" aria-atomic="true" data-id="element-277" data-mp="3k4tiumqn0igq">
      <AnimatePresence data-id="element-278" data-mp="3o7zk1fyw7jgc">
        {pop && <motion.div key={pop.id} className="flex w-full max-w-sm items-center gap-3 rounded-xl border border-bark/10 bg-cream/95 p-3 shadow-lift backdrop-blur" initial={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-279" data-mp="1unxyosi2g4pj">
            <img src={MOCKUP} alt="" aria-hidden="true" className="h-12 w-12 shrink-0 rounded-lg object-cover" data-id="element-280" data-mp="2dk7h1s003hfc" />
            <div className="min-w-0" data-id="element-281" data-mp="23o46bxr32ags">
              {pop.type === 'access' ? <p className="text-sm leading-snug text-bark" data-id="element-282" data-mp="23mjckaclevjz">
                  <strong className="font-semibold" data-id="element-283" data-mp="1znaif4dn4vnw">{pop.name}</strong> accedió a{' '}
                  <span className="font-medium" data-id="element-284" data-mp="s8p7spj87ajk">Código Cortisol: 7 días</span>
                </p> : <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-285" data-mp="o7dh0gom8j9s">
                  <p className="text-sm leading-snug text-bark" data-id="element-286" data-mp="o9gh5tjhfss8">
                    <strong className="font-semibold" data-id="element-287" data-mp="2zvqtg5gwe02f">{pop.name}</strong> calificó
                  </p>
                  <Stars label="5 de 5 estrellas" data-id="element-288" data-mp="33x3wk7slvp5n" />
                  <p className="text-sm leading-snug text-bark" data-id="element-289" data-mp="38vdtonxw4ztw">
                    a <span className="font-medium" data-id="element-290" data-mp="38u2qoqc9rw3u">Código Cortisol: 7 días</span>
                  </p>
                </div>}
              <p className="mt-1 flex items-center gap-1.5 text-xs text-ink/60" data-id="element-291" data-mp="3dnympn8z38wd">
                <CheckIcon className="h-3 w-3 text-trust" aria-hidden="true" data-id="element-292" data-mp="3inb5nwwq3vto" />
                Hace {pop.minutes} {pop.minutes === 1 ? 'minuto' : 'minutos'} · Compra verificada
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}